<template>
  <slot v-bind="{ activator }"/>

  <modal
    :show="showModal"
    :initial-focus="confirmButton"
    @close="closeModal"
    @keydown.ctrl.enter="submit"
    @keydown.meta.enter="submit"
  >
    <template #title>
      {{ title }}
    </template>

    <template #body>
      {{ body }}
    </template>

    <template #footer>
      <l-form class="mb-0" :action="formAction" :method="formMethod">
        <l-button
          ref="confirmButton"
          type="submit"
          :variant="buttonVariant"
        >
          {{ buttonLabel }}
        </l-button>
      </l-form>

      <l-button variant="light" @click="closeModal">
        Cancel
      </l-button>
    </template>
  </modal>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import LForm from "@/components/forms/LForm.vue"
import Modal from "@/components/modals/Modal.vue"
import { ref } from "vue"

defineProps({
  title: { type: String, required: true },
  body: { type: String, required: true },
  buttonLabel: { type: String, default: "Ok" },
  buttonVariant: { type: String, default: "primary" },
  formAction: { type: String, required: true },
  formMethod: { type: String, default: "post" },
})

const confirmButton = ref(null)
const showModal = ref(false)

const closeModal = () => {
  showModal.value = false
}

const activator = () => {
  showModal.value = true
}

const submit = () => {
  confirmButton.value.$el.click()
}
</script>
